import ModelUtil from '@leverege/model-util';
import StringUtil from '@leverege/string-util';
import { createImagineAggregationBuilder } from "../AggregationBuilder.js";
const imagineType = 'stats';
const TYPE = `aggregation.${imagineType}`;
function create() {
  return {
    type: TYPE,
    field: null,
    missing: null,
    script: null,
    attrName: null
  };
}
function getValueType(model) {
  return 'stats';
}
export default {
  create,
  TYPE,
  name: StringUtil.camelCaseToTitleCase(imagineType),
  ...ModelUtil.createAllValue('field'),
  ...ModelUtil.createAllValue('missing'),
  ...ModelUtil.createAllValue('script'),
  ...ModelUtil.createAllValue('attrName'),
  toImagineAgg: createImagineAggregationBuilder(imagineType),
  getValueType
};